/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from '@ngx-translate/core/src/translate.pipe';
import * as i3 from '@ngx-translate/core/src/translate.service';
import * as i4 from '@angular/router';
import * as i5 from 'angular2-moment/date-format.pipe';
import * as i6 from 'angular2-moment/locale.pipe';
import * as i7 from '../../../../../src/app/dashboard/order-list/order-list.component';
import * as i8 from '../../../../../src/app/order/order.service';
var styles_OrderListComponent = [];
export var RenderType_OrderListComponent = i0.ɵcrt({ encapsulation: 2,
    styles: styles_OrderListComponent, data: {} });
function View_OrderListComponent_1(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 6, 'tr', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 3, 'td', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                    '])),
        (_l()(), i0.ɵeld(0, null, null, 0, 'div', [['class', 'loading-animation']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵted(null, ['\n            ']))], null, null);
}
function View_OrderListComponent_2(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 28, 'tr', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 1, 'td', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, [' ', ' '])), (_l()(),
            i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 3, 'td', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, [' ', ' '])), i0.ɵppd(2),
        i0.ɵppd(2), (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 6, 'td', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, [' '])), (_l()(), i0.ɵeld(0, null, null, 4, 'div', [['class',
                'button']], null, null, null, null, null)),
        i0.ɵdid(278528, null, 0, i1.NgClass, [i0.IterableDiffers, i0.KeyValueDiffers,
            i0.ElementRef, i0.Renderer], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null),
        i0.ɵpod({ 'label': 0, 'label-warning': 1, 'label-primary': 2 }), (_l()(), i0.ɵted(null, ['', ''])), i0.ɵpid(131072, i2.TranslatePipe, [i3.TranslateService, i0.ChangeDetectorRef]),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 1, 'td', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, [' ', ' '])),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 6, 'td', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, [' '])), (_l()(),
            i0.ɵeld(0, null, null, 3, 'a', [['class', 'details']], [[1, 'target',
                    0], [8, 'href', 4]], [[null, 'click']], function (_v, en, $event) {
                var ad = true;
                if (('click' === en)) {
                    var pd_0 = (i0.ɵnov(_v, 24).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                    ad = (pd_0 && ad);
                }
                return ad;
            }, null, null)), i0.ɵdid(671744, null, 0, i4.RouterLinkWithHref, [i4.Router, i4.ActivatedRoute, i1.LocationStrategy], { routerLink: [0, 'routerLink'] }, null), i0.ɵpad(2), (_l()(), i0.ɵted(null, ['Details'])), (_l()(),
            i0.ɵted(null, [' '])), (_l()(), i0.ɵted(null, ['\n            ']))], function (_ck, _v) {
        var currVal_2 = 'button';
        var currVal_3 = _ck(_v, 14, 0, true, (_v.context.$implicit.Status.Name == 'IN_PROGRESS'), (_v.context.$implicit.Status.Name == 'SHIPPED'));
        _ck(_v, 13, 0, currVal_2, currVal_3);
        var currVal_8 = _ck(_v, 25, 0, '/dashboard/order', _v.context.$implicit.id);
        _ck(_v, 24, 0, currVal_8);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _v.context.$implicit.uptimeId;
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = i0.ɵunv(_v, 6, 0, _ck(_v, 8, 0, i0.ɵnov(_v.parent, 0), i0.ɵunv(_v, 6, 0, _ck(_v, 7, 0, i0.ɵnov(_v.parent, 1), _v.context.$implicit.createdAt, _co.translate.currentLang)), 'L'));
        _ck(_v, 6, 0, currVal_1);
        var currVal_4 = i0.ɵunv(_v, 15, 0, i0.ɵnov(_v, 16).transform(_v.context.$implicit.Status.Name));
        _ck(_v, 15, 0, currVal_4);
        var currVal_5 = _v.context.$implicit.orderType;
        _ck(_v, 19, 0, currVal_5);
        var currVal_6 = i0.ɵnov(_v, 24).target;
        var currVal_7 = i0.ɵnov(_v, 24).href;
        _ck(_v, 23, 0, currVal_6, currVal_7);
    });
}
export function View_OrderListComponent_0(_l) {
    return i0.ɵvid(0, [i0.ɵpid(0, i5.DateFormatPipe, []), i0.ɵpid(0, i6.LocalePipe, []), (_l()(), i0.ɵeld(0, null, null, 34, 'div', [['class',
                'table-responsive']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵeld(0, null, null, 31, 'table', [['class', 'table']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n        '])),
        (_l()(), i0.ɵeld(0, null, null, 18, 'thead', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 15, 'tr', [], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 1, 'th', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Order ID'])),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 1, 'th', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Date added'])),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 1, 'th', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Status'])),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 1, 'th', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Order type'])),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 0, 'th', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 8, 'tbody', [], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_OrderListComponent_1)),
        i0.ɵdid(16384, null, 0, i1.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n            '])),
        (_l()(), i0.ɵand(16777216, null, null, 2, null, View_OrderListComponent_2)),
        i0.ɵdid(802816, null, 0, i1.NgForOf, [i0.ViewContainerRef, i0.TemplateRef,
            i0.IterableDiffers], { ngForOf: [0, 'ngForOf'] }, null), i0.ɵpid(131072, i1.AsyncPipe, [i0.ChangeDetectorRef]), (_l()(), i0.ɵted(null, ['\n        '])),
        (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵted(null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.loading;
        _ck(_v, 29, 0, currVal_0);
        var currVal_1 = i0.ɵunv(_v, 32, 0, i0.ɵnov(_v, 33).transform(_co.list));
        _ck(_v, 32, 0, currVal_1);
    }, null);
}
export function View_OrderListComponent_Host_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 1, 'cx-dashboard-order-list', [], null, null, null, View_OrderListComponent_0, RenderType_OrderListComponent)), i0.ɵdid(114688, null, 0, i7.OrderListComponent, [i8.OrderService, i3.TranslateService], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
export var OrderListComponentNgFactory = i0.ɵccf('cx-dashboard-order-list', i7.OrderListComponent, View_OrderListComponent_Host_0, {}, {}, []);
//# sourceMappingURL=order-list.component.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./aot/src/app/dashboard/order-list/order-list.component.ngfactory.js
// module id = 1188
// module chunks = 0